import { jsPDF } from "jspdf";
// import { addHeaderAndFooter } from "./addHeaderAndFooter";
import { addPics } from "./addPics";
import { addPage } from "./addPage";
import { setFont } from "./setFont";
// import { addContacts } from "./addContacts";
// import { addComments } from "./addComments";
// import { addTextLine } from "./addTextLine";
// import { addStatusChanges } from "./addStatusChanges";
import { addFormattedText } from "./addFormattedText";
import obsDoc from "./obsDoc";
// import moment from "moment";
import calibri from "../../fonts/Calibri.ttf";
import calibrib from "../../fonts/calibrib.ttf";
import calibrii from "../../fonts/calibrii.ttf";
import calibriz from "../../fonts/calibriz.ttf";
import { applyHeaderAndFooter } from "./applyHeaderAndFooter";
import { exportChecklistRows } from "./exportChecklistRows";

export async function exportEquipment(project, equipment_id, template) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "in",
    format: "letter",
    compress: true,
  });

  console.log(doc.internal.pageSize);
  const pageHeight = doc.internal.pageSize.height - 1; // Get page height minus some

  const equipment =
    project.Equipment.find((e) => e.id === equipment_id) || null;
  var cursorY = 1.5; //initial cursor position

  //Add custom font
  doc.addFont(calibri, "calibri", "normal");
  doc.addFont(calibrib, "calibri", "bold");
  doc.addFont(calibrii, "calibri", "italic");
  doc.addFont(calibriz, "calibri", "bold_italic");

  setFont(doc, false);
  //Header & footer logo
  // await addHeaderAndFooter(doc);
  setFont(doc, true);

  for (let z = 0; z < template.length; z++) {
    //addPage if at bottom of page
    if (cursorY + 1 > pageHeight) {
      cursorY = await addPage(doc, cursorY);
    }

    const section = template[z];
    //section header
    setFont(doc, true);
    doc.text(
      section.name === "Equipment"
        ? `Equipment Name ${equipment.Name}`
        : section.name === "Project"
          ? `Project: ${project.Name}`
          : section.name,
      doc.internal.pageSize.width / 2,
      cursorY,
      {
        align: "center",
      },
    );

    const objArry =
      section.name === "Project"
        ? [project]
        : section.name === "Contacts"
          ? project.Contacts
          : // : section.name === "Issue"
            //   ? [issue]
            section.name === "Equipment"
            ? [equipment]
            : section.name === "Comments"
              ? project["Comments"].filter(
                  (c) => c.equipment_id === equipment_id,
                )
              : section.name === "Issues"
                ? project["Issues"].filter(
                    (c) => c.equipment_id === equipment_id,
                  )
                : section.name === "Checklists"
                  ? project["Checklists"].filter(
                      (c) => c.equipment_id === equipment_id,
                    )
                  : [];

    cursorY += obsDoc.lineSpacing * 2;

    for (let y = 0; y < objArry.length; y++) {
      const secObj = objArry[y];
      for (let i = 0; i < section.fields.length; i++) {
        const fd = section.fields[i];
        if (fd.name === "Show Pictures?" && fd.checked) {
          //issue Pics
          cursorY = await addPics(
            doc,
            section.name === "Equipment"
              ? project.Files.filter(
                  (f) =>
                    (f.equipment_id === equipment_id &&
                      f.name.endsWith(".jpg")) ||
                    (f.equipment_id === equipment_id &&
                      f.name.endsWith(".png")) ||
                    (f.equipment_id === equipment_id &&
                      f.name.endsWith(".jpeg")),
                )
              : section.name.toLowerCase().includes("comments")
                ? project.Files.filter(
                    (f) =>
                      (f.comment_id === secObj.id && f.name.endsWith(".jpg")) ||
                      (f.comment_id === secObj.id && f.name.endsWith(".png")) ||
                      (f.comment_id === secObj.id && f.name.endsWith(".jpeg")),
                  )
                : [],
            cursorY,
          );
        } else if (secObj[fd.name] === "Show Files?" && fd.checked) {
          // cursorY = await addPage(doc, cursorY);
        } else if (fd.checked) {
          setFont(doc, true);
          doc.text(fd.name + ":", obsDoc.xPosition, cursorY);
          cursorY += obsDoc.lineSpacing;
          setFont(doc, false);
          if (Array.isArray(secObj[fd.name]) && fd.name == "rows") {
            cursorY = await exportChecklistRows(doc, secObj[fd.name], cursorY);
          } else {
            cursorY = await addFormattedText(
              doc,
              cursorY,
              typeof secObj[fd.name] === "object" &&
                secObj[fd.name].hasOwnProperty("seconds")
                ? new Date(secObj[fd.name].seconds * 1000).toLocaleDateString()
                : typeof secObj[fd.name] === "object" &&
                    !secObj[fd.name].hasOwnProperty("seconds")
                  ? ""
                  : secObj[fd.name],
            );
          }
        }
      }
      //move cursor down between sections
      cursorY += obsDoc.lineSpacing * 2;
    }
  }

  //     //issue pics header
  //     if (issues[i].pics.length > 0) {
  //       cursorY += obsDoc.lineSpacing;
  //       setFont(doc, true);
  //       cursorY = await addTextLine(doc, cursorY, "Issue Photos:");
  //       setFont(doc, false);

  //       //issue Pics
  //       cursorY = await addPics(doc, issues[i].pics, cursorY);
  //     }

  //     cursorY += obsDoc.lineSpacing;

  // will save the file in the current working directory

  await applyHeaderAndFooter(doc, 0, project.uid);

  return await doc.save(
    project.Name.replace(/[/\\?%*:|"<>]/g, "-") +
      `_Equipment_Name_${equipment.Name}.pdf`,
    { returnPromise: true },
  );
}
